/* eslint-disable @typescript-eslint/no-explicit-any */
export const UnitKeys = {
  allUnits: ['Units'] as const,
  listUnits: () => [...UnitKeys.allUnits, 'listUnits'] as const,
  listUnit: (params: any) => [...UnitKeys.listUnits(), { params }] as const,
}
